export const ENV =
   {
     ENV : 'prod',
     HOST_BACKEND: 'https://app.usebump.com' || window.location.protocol + '//' + window.location.hostname,
     HIGHNOTE_ORGANIZATION_ID: 'og_bs018751dfe131f64a3ea498dfd7ad5b5f83',
     HIGHNOTE_PRODUCT_ID: 'pd_421bf53597db4f6a947381a577ef38f8',
};